/**
 * @module
 * @author Bayu Dwiyan Satria
 * @since 1.0.0
 */

/**
 * Utilities
 */
import { httpClient } from '@/core/http'

/**
 * Types
 */
import type { ApiResponse } from '@/types/api'
import type { HealthCheck } from '@/types/health'

/**
 * Health endpoint client — the worked example for this layer.
 *
 * @remarks
 * A service is where an endpoint's shape lives: its path, its response type, and any mapping the
 * rest of the app should not have to know about. Components import services; they never import
 * `httpClient` directly, which is what stops the same endpoint being called three slightly
 * different ways from three views.
 *
 * Delete this file, `types/health.ts` and the matching Pages Function when forking — see
 * AGENTS.md § When Forking This Template.
 *
 * @example
 * ```ts
 * import { api } from '@/services/client'
 *
 * const { data } = await api.health.getStatus()
 * ```
 */
export const healthService = {
  /** Fetch the API's current health. */
  getStatus: (signal?: AbortSignal): Promise<ApiResponse<HealthCheck>> =>
    httpClient.get<ApiResponse<HealthCheck>>('/health', { signal })
}
